import { useWoAttachmentsAuthorizationEnabled } from '../../feature-flags/useWoAttachmentsAuthorizationEnabled';
import { useActor } from '../authorization/useActor';
import type { AttachmentAccess } from './getAttachmentAccess';
import { getPmTaskAttachmentAccess } from './getPmAttachmentAccess';
import type { PmTaskRecord } from './toPmResource';

export const usePmTaskAttachmentAccess = (
  record: PmTaskRecord
): AttachmentAccess =>
  getPmTaskAttachmentAccess({
    actor: useActor(),
    record,
    isEnforced: useWoAttachmentsAuthorizationEnabled(),
  });
